import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { usePermissions } from '../../hooks/usePermissions';
import { useMunicipalMidias } from './hooks/useMunicipalConfig';
import { MediaCenterCore } from '../../components/medias/MediaCenterCore';
import {
  MUNICIPAL_MEDIA_CATEGORIAS,
  type MediaConfig,
  type MediaItem,
  type MediaUploadPayload,
} from '../../components/medias/MediaConfig';

export function MidiasMunicipal() {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const { canManage } = usePermissions();
  const municipioId = user?.municipioId || '';
  const { midias, isLoading, create, remove } = useMunicipalMidias();

  const config: MediaConfig = useMemo(
    () => ({
      scope: 'MUNICIPAL',
      scopeId: municipioId || '',
      labels: {
        heroTitle: 'Banco de Mídias Municipal',
        heroSubtitle:
          'Acervo digital de comunicados visuais, banners e artes oficiais para enviar às famílias da rede municipal.',
        searchPlaceholder: 'Buscar mídias da rede municipal...',
        emptyTitle: 'Nenhuma mídia cadastrada ainda',
        emptySubtitle:
          'Crie seu acervo digital de comunicados visuais, banners e artes oficiais para enviar às famílias da rede municipal.',
      },
      categories: MUNICIPAL_MEDIA_CATEGORIAS,
      features: {
        allowCompress: true,
        maxFileSizeMb: 10,
        showHowItWorksBanner: true,
        showSetupHero: false,
        canManage: canManage('comunicados'),
      },
      onSendToComunicado: (m: MediaItem) => {
        navigate('/municipal/comunicados', {
          state: {
            createFromMidia: {
              titulo: m.titulo,
              categoria:
                m.categoria === 'CAMPANHA' || m.categoria === 'OBRA'
                  ? 'INSTITUCIONAL'
                  : 'OPERACIONAL',
              descricao: m.descricao || `Comunicado oficial: ${m.titulo}`,
              midiaUrl: m.arquivoUrl,
            },
          },
        });
      },
    }),
    [municipioId, navigate],
  );

  return (
    <MediaCenterCore
      config={config}
      midias={midias as unknown as MediaItem[]}
      isLoading={isLoading}
      onCreate={(payload: MediaUploadPayload) => create.mutateAsync(payload)}
      onRemove={(id: string) => remove.mutateAsync(id)}
    />
  );
}
